import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showSideBar: false,
  noti_refresh: false,
  showSearchPopUP: false,
  exportLoading: false,
};

const UISlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleSideBar(state) {
      state.showSideBar = !state.showSideBar;
    },
    showSearchPopUP(state) {
      state.showSearchPopUP = true;
    },
    hideSearchPopUP(state) {
      state.showSearchPopUP = false;
    },
    setNotiRefresh(state) {
      state.noti_refresh = !state.noti_refresh;
    },
    setExportLoading(state) {
      state.exportLoading = !state.exportLoading;
    },
  },
});

export const {
  toggleSideBar,
  setNotiRefresh,
  showSearchPopUP,
  hideSearchPopUP,
  setExportLoading,
} = UISlice.actions;
export default UISlice.reducer;
